/**
 * 资源封面的同源代理地址.
 *
 * CDN 签名地址每次接口响应都会变, 直接放进 <img> 会让浏览器每次都重新下载;
 * 这里改走 `/api/v1/courses/{id}/cover`, 后端回 7 天 Cache-Control,
 * 浏览器按资源 id + 规范路径版本缓存, 换封面后版本变化才会重新拉取.
 */

interface CoverSource {
  id: number
  cover_url: string
}

/** FNV-1a: 只用来做短版本号, 不需要密码学强度 */
function coverVersion(canonical: string): string {
  let hash = 2166136261
  for (let index = 0; index < canonical.length; index += 1) {
    hash ^= canonical.charCodeAt(index)
    hash = Math.imul(hash, 16777619)
  }
  return (hash >>> 0).toString(36)
}

export function coverSrc(course: CoverSource | undefined): string {
  if (!course?.cover_url) return ''
  // 去掉每次都会变化的 auth_key, 只保留规范路径
  const canonical = course.cover_url.split('?')[0] ?? ''
  return `/api/v1/courses/${course.id}/cover?v=${coverVersion(canonical)}`
}
